import React from 'react';

// Заглушка загрузки: мерцающий блок. Вместо спиннера в списках, карточках KPI и ленте.
// При prefers-reduced-motion и в упрощённом виде мерцание отключается (index.css).
export function Skeleton({ className = 'h-4 w-full', rounded = '' }) {
  return <div aria-hidden="true" className={`skeleton ${rounded} ${className}`} />;
}

// Строки списка/таблицы: n полос с аватаром слева
export function SkeletonRows({ rows = 6, avatar = true }) {
  return (
    <div role="status" aria-busy="true" aria-live="polite" className="divide-y divide-surface-100">
      <span className="sr-only">…</span>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3">
          {avatar && <Skeleton className="w-8 h-8 shrink-0" rounded="rounded-full" />}
          <div className="flex-1 space-y-2"><Skeleton className="h-3.5 w-2/5" /><Skeleton className="h-3 w-3/5" /></div>
          <Skeleton className="h-3.5 w-16" />
        </div>
      ))}
    </div>
  );
}

// Карточки KPI на дашборде и в аналитике
export function SkeletonCards({ count = 4 }) {
  return (
    <div role="status" aria-busy="true" className="grid gap-3 grid-cols-2 lg:grid-cols-4">
      <span className="sr-only">…</span>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="card p-4 space-y-3"><Skeleton className="h-3 w-1/2" /><Skeleton className="h-7 w-2/3" /><Skeleton className="h-3 w-1/3" /></div>
      ))}
    </div>
  );
}

export default Skeleton;
